import React from 'react';

export default function ProcessFlowchartConfigEditorLeftSidepanel(): JSX.Element {
  // TODO: Add left sidepanel content
  return <div>Left Sidepanel</div>;
}
